// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as ArticleRouteImport } from './routes/article'
import { Route as AvisoDePrivacidadeRouteImport } from './routes/aviso-de-privacidade'
import { Route as BlogSeoPreviewRouteImport } from './routes/blog-seo-preview'
import { Route as BreadcrumbListRouteImport } from './routes/breadcrumb-list'
import { Route as CalculadoraWhatsappOutubro2026RouteImport } from './routes/calculadora-whatsapp-outubro-2026'
import { Route as CasesRouteImport } from './routes/cases'
import { Route as ChatgptRouteImport } from './routes/chatgpt'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as EquipeRouteImport } from './routes/equipe'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as FormsFullRouteImport } from './routes/forms-full'
import { Route as Forms1RouteImport } from './routes/forms1'
import { Route as FortalecendoACulturaEmpresarialAtravesDaGestaoDeAtendimentoRouteImport } from './routes/fortalecendo-a-cultura-empresarial-atraves-da-gestao-de-atendimento'
import { Route as GestaoDeAtendimentoRouteImport } from './routes/gestao-de-atendimento'
import { Route as GoogleRouteImport } from './routes/google'
import { Route as IaRouteImport } from './routes/ia'
import { Route as InstagramRouteImport } from './routes/instagram'
import { Route as IntegracaoRouteImport } from './routes/integracao'
import { Route as IntegracoesRouteImport } from './routes/integracoes'
import { Route as KentroouvidoriaRouteImport } from './routes/kentroouvidoria'
import { Route as LgpdRouteImport } from './routes/lgpd'
import { Route as MagistralRouteImport } from './routes/magistral'
import { Route as MedindoOImpactoEmocionalDasReclamacoesDosClientesAprimorandoProcessosParaOSucessoRouteImport } from './routes/medindo-o-impacto-emocional-das-reclamacoes-dos-clientes-aprimorando-processos-para-o-sucesso'
import { Route as OmnichannelRouteImport } from './routes/omnichannel'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as OuvidoriaRouteImport } from './routes/ouvidoria'
import { Route as ParceriaRouteImport } from './routes/parceria'
import { Route as PerguntasFrequentesRouteImport } from './routes/perguntas-frequentes'
import { Route as PoliticaDeCookiesRouteImport } from './routes/politica-de-cookies'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as ProductRouteImport } from './routes/product'
import { Route as RelatorioLeadsRouteImport } from './routes/relatorio-leads'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as ServiceRouteImport } from './routes/service'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as SoftwareApplicationRouteImport } from './routes/software-application'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as TiktokRouteImport } from './routes/tiktok'
import { Route as VideoObjectRouteImport } from './routes/video-object'
import { Route as WdecRouteImport } from './routes/wdec'
import { Route as WebsiteRouteImport } from './routes/website'
import { Route as LocaleIndexRouteImport } from './routes/$locale.index'
import { Route as LocaleAvisoDePrivacidadeRouteImport } from './routes/$locale.aviso-de-privacidade'
import { Route as LocaleBlogRouteImport } from './routes/$locale.blog'
import { Route as LocaleCasesRouteImport } from './routes/$locale.cases'
import { Route as LocaleContatoRouteImport } from './routes/$locale.contato'
import { Route as LocaleGestaoDeAtendimentoRouteImport } from './routes/$locale.gestao-de-atendimento'
import { Route as LocaleGoogleRouteImport } from './routes/$locale.google'
import { Route as LocaleIaRouteImport } from './routes/$locale.ia'
import { Route as LocaleInstagramRouteImport } from './routes/$locale.instagram'
import { Route as LocaleIntegracoesRouteImport } from './routes/$locale.integracoes'
import { Route as LocaleOmnichannelRouteImport } from './routes/$locale.omnichannel'
import { Route as LocaleOuvidoriaRouteImport } from './routes/$locale.ouvidoria'
import { Route as LocaleParceriaRouteImport } from './routes/$locale.parceria'
import { Route as LocalePrivacidadeRouteImport } from './routes/$locale.privacidade'
import { Route as LocaleSobreRouteImport } from './routes/$locale.sobre'
import { Route as LocaleTiktokRouteImport } from './routes/$locale.tiktok'
import { Route as LocaleWdecRouteImport } from './routes/$locale.wdec'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogHiperpersonalizacaoRouteImport } from './routes/blog.hiperpersonalizacao'
import { Route as ClinicasIndexRouteImport } from './routes/clinicas.index'
import { Route as ClinicasVerticalRouteImport } from './routes/clinicas.$vertical'
import { Route as FuncionalidadesIndexRouteImport } from './routes/funcionalidades.index'
import { Route as FuncionalidadesModuloRouteImport } from './routes/funcionalidades.$modulo'
import { Route as SegmentosSlugRouteImport } from './routes/segmentos.$slug'
import { Route as LocaleBlogSlugRouteImport } from './routes/$locale.blog.$slug'
import { Route as LocaleSegmentosSlugRouteImport } from './routes/$locale.segmentos.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const ArticleRoute = ArticleRouteImport.update({
            id: '/article',path: '/article',getParentRoute: () => rootRouteImport
          })
const AvisoDePrivacidadeRoute = AvisoDePrivacidadeRouteImport.update({
            id: '/aviso-de-privacidade',path: '/aviso-de-privacidade',getParentRoute: () => rootRouteImport
          })
const BlogSeoPreviewRoute = BlogSeoPreviewRouteImport.update({
            id: '/blog-seo-preview',path: '/blog-seo-preview',getParentRoute: () => rootRouteImport
          })
const BreadcrumbListRoute = BreadcrumbListRouteImport.update({
            id: '/breadcrumb-list',path: '/breadcrumb-list',getParentRoute: () => rootRouteImport
          })
const CalculadoraWhatsappOutubro2026Route = CalculadoraWhatsappOutubro2026RouteImport.update({
            id: '/calculadora-whatsapp-outubro-2026',path: '/calculadora-whatsapp-outubro-2026',getParentRoute: () => rootRouteImport
          })
const CasesRoute = CasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => rootRouteImport
          })
const ChatgptRoute = ChatgptRouteImport.update({
            id: '/chatgpt',path: '/chatgpt',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const EquipeRoute = EquipeRouteImport.update({
            id: '/equipe',path: '/equipe',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FeedRoute = FeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => rootRouteImport
          })
const FormsFullRoute = FormsFullRouteImport.update({
            id: '/forms-full',path: '/forms-full',getParentRoute: () => rootRouteImport
          })
const Forms1Route = Forms1RouteImport.update({
            id: '/forms1',path: '/forms1',getParentRoute: () => rootRouteImport
          })
const FortalecendoACulturaEmpresarialAtravesDaGestaoDeAtendimentoRoute = FortalecendoACulturaEmpresarialAtravesDaGestaoDeAtendimentoRouteImport.update({
            id: '/fortalecendo-a-cultura-empresarial-atraves-da-gestao-de-atendimento',path: '/fortalecendo-a-cultura-empresarial-atraves-da-gestao-de-atendimento',getParentRoute: () => rootRouteImport
          })
const GestaoDeAtendimentoRoute = GestaoDeAtendimentoRouteImport.update({
            id: '/gestao-de-atendimento',path: '/gestao-de-atendimento',getParentRoute: () => rootRouteImport
          })
const GoogleRoute = GoogleRouteImport.update({
            id: '/google',path: '/google',getParentRoute: () => rootRouteImport
          })
const IaRoute = IaRouteImport.update({
            id: '/ia',path: '/ia',getParentRoute: () => rootRouteImport
          })
const InstagramRoute = InstagramRouteImport.update({
            id: '/instagram',path: '/instagram',getParentRoute: () => rootRouteImport
          })
const IntegracaoRoute = IntegracaoRouteImport.update({
            id: '/integracao',path: '/integracao',getParentRoute: () => rootRouteImport
          })
const IntegracoesRoute = IntegracoesRouteImport.update({
            id: '/integracoes',path: '/integracoes',getParentRoute: () => rootRouteImport
          })
const KentroouvidoriaRoute = KentroouvidoriaRouteImport.update({
            id: '/kentroouvidoria',path: '/kentroouvidoria',getParentRoute: () => rootRouteImport
          })
const LgpdRoute = LgpdRouteImport.update({
            id: '/lgpd',path: '/lgpd',getParentRoute: () => rootRouteImport
          })
const MagistralRoute = MagistralRouteImport.update({
            id: '/magistral',path: '/magistral',getParentRoute: () => rootRouteImport
          })
const MedindoOImpactoEmocionalDasReclamacoesDosClientesAprimorandoProcessosParaOSucessoRoute = MedindoOImpactoEmocionalDasReclamacoesDosClientesAprimorandoProcessosParaOSucessoRouteImport.update({
            id: '/medindo-o-impacto-emocional-das-reclamacoes-dos-clientes-aprimorando-processos-para-o-sucesso',path: '/medindo-o-impacto-emocional-das-reclamacoes-dos-clientes-aprimorando-processos-para-o-sucesso',getParentRoute: () => rootRouteImport
          })
const OmnichannelRoute = OmnichannelRouteImport.update({
            id: '/omnichannel',path: '/omnichannel',getParentRoute: () => rootRouteImport
          })
const OrganizationRoute = OrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => rootRouteImport
          })
const OuvidoriaRoute = OuvidoriaRouteImport.update({
            id: '/ouvidoria',path: '/ouvidoria',getParentRoute: () => rootRouteImport
          })
const ParceriaRoute = ParceriaRouteImport.update({
            id: '/parceria',path: '/parceria',getParentRoute: () => rootRouteImport
          })
const PerguntasFrequentesRoute = PerguntasFrequentesRouteImport.update({
            id: '/perguntas-frequentes',path: '/perguntas-frequentes',getParentRoute: () => rootRouteImport
          })
const PoliticaDeCookiesRoute = PoliticaDeCookiesRouteImport.update({
            id: '/politica-de-cookies',path: '/politica-de-cookies',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const ProductRoute = ProductRouteImport.update({
            id: '/product',path: '/product',getParentRoute: () => rootRouteImport
          })
const RelatorioLeadsRoute = RelatorioLeadsRouteImport.update({
            id: '/relatorio-leads',path: '/relatorio-leads',getParentRoute: () => rootRouteImport
          })
const ReviewRoute = ReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => rootRouteImport
          })
const ServiceRoute = ServiceRouteImport.update({
            id: '/service',path: '/service',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const SoftwareApplicationRoute = SoftwareApplicationRouteImport.update({
            id: '/software-application',path: '/software-application',getParentRoute: () => rootRouteImport
          })
const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const TiktokRoute = TiktokRouteImport.update({
            id: '/tiktok',path: '/tiktok',getParentRoute: () => rootRouteImport
          })
const VideoObjectRoute = VideoObjectRouteImport.update({
            id: '/video-object',path: '/video-object',getParentRoute: () => rootRouteImport
          })
const WdecRoute = WdecRouteImport.update({
            id: '/wdec',path: '/wdec',getParentRoute: () => rootRouteImport
          })
const WebsiteRoute = WebsiteRouteImport.update({
            id: '/website',path: '/website',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocaleAvisoDePrivacidadeRoute = LocaleAvisoDePrivacidadeRouteImport.update({
            id: '/aviso-de-privacidade',path: '/aviso-de-privacidade',getParentRoute: () => LocaleRoute
          })
const LocaleBlogRoute = LocaleBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => LocaleRoute
          })
const LocaleCasesRoute = LocaleCasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => LocaleRoute
          })
const LocaleContatoRoute = LocaleContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => LocaleRoute
          })
const LocaleGestaoDeAtendimentoRoute = LocaleGestaoDeAtendimentoRouteImport.update({
            id: '/gestao-de-atendimento',path: '/gestao-de-atendimento',getParentRoute: () => LocaleRoute
          })
const LocaleGoogleRoute = LocaleGoogleRouteImport.update({
            id: '/google',path: '/google',getParentRoute: () => LocaleRoute
          })
const LocaleIaRoute = LocaleIaRouteImport.update({
            id: '/ia',path: '/ia',getParentRoute: () => LocaleRoute
          })
const LocaleInstagramRoute = LocaleInstagramRouteImport.update({
            id: '/instagram',path: '/instagram',getParentRoute: () => LocaleRoute
          })
const LocaleIntegracoesRoute = LocaleIntegracoesRouteImport.update({
            id: '/integracoes',path: '/integracoes',getParentRoute: () => LocaleRoute
          })
const LocaleOmnichannelRoute = LocaleOmnichannelRouteImport.update({
            id: '/omnichannel',path: '/omnichannel',getParentRoute: () => LocaleRoute
          })
const LocaleOuvidoriaRoute = LocaleOuvidoriaRouteImport.update({
            id: '/ouvidoria',path: '/ouvidoria',getParentRoute: () => LocaleRoute
          })
const LocaleParceriaRoute = LocaleParceriaRouteImport.update({
            id: '/parceria',path: '/parceria',getParentRoute: () => LocaleRoute
          })
const LocalePrivacidadeRoute = LocalePrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => LocaleRoute
          })
const LocaleSobreRoute = LocaleSobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => LocaleRoute
          })
const LocaleTiktokRoute = LocaleTiktokRouteImport.update({
            id: '/tiktok',path: '/tiktok',getParentRoute: () => LocaleRoute
          })
const LocaleWdecRoute = LocaleWdecRouteImport.update({
            id: '/wdec',path: '/wdec',getParentRoute: () => LocaleRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogHiperpersonalizacaoRoute = BlogHiperpersonalizacaoRouteImport.update({
            id: '/blog/hiperpersonalizacao',path: '/blog/hiperpersonalizacao',getParentRoute: () => rootRouteImport
          })
const ClinicasIndexRoute = ClinicasIndexRouteImport.update({
            id: '/clinicas/',path: '/clinicas/',getParentRoute: () => rootRouteImport
          })
const ClinicasVerticalRoute = ClinicasVerticalRouteImport.update({
            id: '/clinicas/$vertical',path: '/clinicas/$vertical',getParentRoute: () => rootRouteImport
          })
const FuncionalidadesIndexRoute = FuncionalidadesIndexRouteImport.update({
            id: '/funcionalidades/',path: '/funcionalidades/',getParentRoute: () => rootRouteImport
          })
const FuncionalidadesModuloRoute = FuncionalidadesModuloRouteImport.update({
            id: '/funcionalidades/$modulo',path: '/funcionalidades/$modulo',getParentRoute: () => rootRouteImport
          })
const SegmentosSlugRoute = SegmentosSlugRouteImport.update({
            id: '/segmentos/$slug',path: '/segmentos/$slug',getParentRoute: () => rootRouteImport
          })
const LocaleBlogSlugRoute = LocaleBlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LocaleBlogRoute
          })
const LocaleSegmentosSlugRoute = LocaleSegmentosSlugRouteImport.update({
            id: '/segmentos/$slug',path: '/segmentos/$slug',getParentRoute: () => LocaleRoute
          })





const LocaleBlogRouteChildren = {
  LocaleBlogSlugRoute: LocaleBlogSlugRoute
}

const LocaleBlogRouteWithChildren = LocaleBlogRoute._addFileChildren(LocaleBlogRouteChildren)



const LocaleRouteChildren = {
  LocaleAvisoDePrivacidadeRoute: LocaleAvisoDePrivacidadeRoute,LocaleBlogRoute: LocaleBlogRouteWithChildren,LocaleCasesRoute: LocaleCasesRoute,LocaleContatoRoute: LocaleContatoRoute,LocaleGestaoDeAtendimentoRoute: LocaleGestaoDeAtendimentoRoute,LocaleGoogleRoute: LocaleGoogleRoute,LocaleIaRoute: LocaleIaRoute,LocaleInstagramRoute: LocaleInstagramRoute,LocaleIntegracoesRoute: LocaleIntegracoesRoute,LocaleOmnichannelRoute: LocaleOmnichannelRoute,LocaleOuvidoriaRoute: LocaleOuvidoriaRoute,LocaleParceriaRoute: LocaleParceriaRoute,LocalePrivacidadeRoute: LocalePrivacidadeRoute,LocaleSobreRoute: LocaleSobreRoute,LocaleTiktokRoute: LocaleTiktokRoute,LocaleWdecRoute: LocaleWdecRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleSegmentosSlugRoute: LocaleSegmentosSlugRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRoute: LocaleRouteWithChildren,ArticleRoute: ArticleRoute,AvisoDePrivacidadeRoute: AvisoDePrivacidadeRoute,BlogSeoPreviewRoute: BlogSeoPreviewRoute,BreadcrumbListRoute: BreadcrumbListRoute,CalculadoraWhatsappOutubro2026Route: CalculadoraWhatsappOutubro2026Route,CasesRoute: CasesRoute,ChatgptRoute: ChatgptRoute,ContatoRoute: ContatoRoute,EquipeRoute: EquipeRoute,FaqRoute: FaqRoute,FeedRoute: FeedRoute,FormsFullRoute: FormsFullRoute,Forms1Route: Forms1Route,FortalecendoACulturaEmpresarialAtravesDaGestaoDeAtendimentoRoute: FortalecendoACulturaEmpresarialAtravesDaGestaoDeAtendimentoRoute,GestaoDeAtendimentoRoute: GestaoDeAtendimentoRoute,GoogleRoute: GoogleRoute,IaRoute: IaRoute,InstagramRoute: InstagramRoute,IntegracaoRoute: IntegracaoRoute,IntegracoesRoute: IntegracoesRoute,KentroouvidoriaRoute: KentroouvidoriaRoute,LgpdRoute: LgpdRoute,MagistralRoute: MagistralRoute,MedindoOImpactoEmocionalDasReclamacoesDosClientesAprimorandoProcessosParaOSucessoRoute: MedindoOImpactoEmocionalDasReclamacoesDosClientesAprimorandoProcessosParaOSucessoRoute,OmnichannelRoute: OmnichannelRoute,OrganizationRoute: OrganizationRoute,OuvidoriaRoute: OuvidoriaRoute,ParceriaRoute: ParceriaRoute,PerguntasFrequentesRoute: PerguntasFrequentesRoute,PoliticaDeCookiesRoute: PoliticaDeCookiesRoute,PrivacidadeRoute: PrivacidadeRoute,ProductRoute: ProductRoute,RelatorioLeadsRoute: RelatorioLeadsRoute,ReviewRoute: ReviewRoute,ServiceRoute: ServiceRoute,SobreRoute: SobreRoute,SoftwareApplicationRoute: SoftwareApplicationRoute,TermosDeUsoRoute: TermosDeUsoRoute,TiktokRoute: TiktokRoute,VideoObjectRoute: VideoObjectRoute,WdecRoute: WdecRoute,WebsiteRoute: WebsiteRoute,BlogSlugRoute: BlogSlugRoute,BlogHiperpersonalizacaoRoute: BlogHiperpersonalizacaoRoute,ClinicasVerticalRoute: ClinicasVerticalRoute,FuncionalidadesModuloRoute: FuncionalidadesModuloRoute,SegmentosSlugRoute: SegmentosSlugRoute,BlogIndexRoute: BlogIndexRoute,ClinicasIndexRoute: ClinicasIndexRoute,FuncionalidadesIndexRoute: FuncionalidadesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)